import { UserPlusIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedTaskAssignedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface TaskAssignedEventProps {
  event: DiscriminatedTaskAssignedEvent;
}

export const TaskAssignedEvent: React.FC<TaskAssignedEventProps> = ({
  event,
}) => {
  const { task, new: newUser } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
          <UserPlusIcon className="h-4 w-4 text-blue-600" />
        </div>
      }
    />
  );

  const assigneeName = newUser
    ? [newUser.first_name, newUser.last_name].filter(Boolean).join(' ') ||
      newUser.username ||
      newUser.email
    : null;

  const body = (
    <ActivityBody>
      {task?.name && <ActivityTitle>{task.name}</ActivityTitle>}
      {assigneeName && (
        <ActivityDescription>Assigned to: {assigneeName}</ActivityDescription>
      )}
    </ActivityBody>
  );

  const actions = task?.id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/updates?task_id=${task.id}`}
      >
        View Task
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Task Assigned"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
